import { VerticalListCSSStyle, VerticalListCSSStyleImpl } from '../verticallistcss';

export interface PaginationVerticalListCSSStyle extends VerticalListCSSStyle
{
   getPaginationCSSStyle(): object;
}

export class PaginationVerticalListCSSStyleImpl extends VerticalListCSSStyleImpl implements PaginationVerticalListCSSStyle
{
    getPaginationCSSStyle(): object 
    {
        return {
            height: "50px",
            width: "100%",
            marginTop: "50px"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationverticallistcss.tsx